import { ENGLISH } from "../../../public/Constants/EnumConstants";

export const HOW_WE_WORK_TITLE =
    "font-Montserrat font-semibold text-[22px] xs:text-2xl sm:text-[32px] mb-4 sm:mb-8";
export const HOW_IT_WORKS_FIRST_ROW =
    " flex flex-col lg:flex-row  gap-4 lg:gap-10 ";
export const HOW_IT_WORKS = "how-it-works";
